<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        h1.m-0
          i Hola {{user.name}}
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
            small {{moment().locale('es').format('MMMM')}} 
            | {{ Math.ceil(moment().date() / 7) }}
            small ra 
            | Semana
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12.col-lg-6
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              .h2.mb-3.ad_text-primary
                | Esta Semana
              h5.mb-2.ad_text-primary Objetivos
              .row
                .col-8
                  .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(objective, index) in objectives")
                    form
                      .d-flex.row.form-group.align-items-end.mb-1
                        .col
                          small
                            a(:id="'provisionhome' + index")
                              i.icon-letters.icon-letters__viaje.mr-1 V
                              i.icon-letters.icon-letters__producto.mr-1 P
                              i.icon-letters.icon-letters__segmento.mr-1 S
                            b-tooltip(:target='"provisionhome" + index' , placement='top')
                              | {{ `${objective._id.travel} - ${objective._id.product} - ${objective._id.segment}`}}
                          small
                            a(:id="'kpihome' + index")
                              i.icon-letters.icon-letters__negocio.mr-1 N
                            b-tooltip(:target='"kpihome" + index' , placement='top')
                              | {{ objective._id.business_type }}
                        .col-auto
                          p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
                            sup Registro
                            span {{ `${objective._id.business_register}`}}%
                          p.d-inline-block.mb-0.ad_text-grayMedio
                            sup Meta
                            span {{ `${objective._id.business_goal}`}}%
                    .d-flex.row
                      .col-12
                        table.w-100.text-center.table-rounded-body
                          thead
                            tr
                              th
                              th.text-left Objetivo
                              th 
                              th.px-1 Registro
                              th.px-0 Meta
                              th
                          tbody(v-for="(obj, iobj) in objective.objectives")
                            tr
                              td
                                div.pl-2.pr-0
                                  span.num_circle.ad_bg-success 1
                              td.text-left
                                div.pl-2
                                  a(:id='"kpi-" + index')
                                    | {{ obj.kpi | truncate(22, '...') }}
                                  b-tooltip(:target='"kpi-" + index' , placement='top')
                                    | {{ obj.kpi }}
                              td
                                div.px-0
                                  span.ad_text-success(v-if="moment().format('W') - moment(obj.date).format('W') === 0")
                                    | {{ moment().format('W') - moment(obj.date).format('W') === 0 ? 1 : moment().format('W') - moment(obj.date).format('W') }}&deg; sem
                                  span.ad_text-warning(v-if="moment().format('W') - moment(obj.date).format('W') === 1")
                                    | {{ moment().format('W') - moment(obj.date).format('W')  }}&deg; sem
                                  span.ad_text-danger(v-if="moment().format('W') - moment(obj.date).format('W') >= 2")
                                    | {{ moment().format('W') - moment(obj.date).format('W') > 3 ? +3 : moment().format('W') - moment(obj.date).format('W') }}&deg; sem
                              td
                                div.px-1
                                  | {{ obj.kpi_register}}%
                              td
                                div.px-0
                                  | {{ obj.goal}}%
                              td
                                div.px-0
                                  a.no-decoration(title="Comentarios" @click='openObjectiveCommentBox(objective, obj)')
                                    i.icono.icono-comentarios.ad_text-primary
                .col-4.pl-0
                  .col-12.d-flex.py-1.ad_border1-secondary.rounded-xxl.align-items-end.justify-content-between.mb-3
                    i.h4.ad_text-secondary.m-0 DDD
                    .h2.ad_text-secondary.m-0 {{ `${myToolsCount.meeting.done}/${user.profile.suggested_ddd}`}}
                  .col-12.d-flex.py-1.ad_border1-secondary.rounded-xxl.align-items-end.justify-content-between.mb-3(v-if="user.profile.auth.tabs.includes('seguimiento_diario') || user.profile.auth.tabs.includes('confirmacion_procesos')")
                    i.h4.ad_text-secondary.m-0 {{ user.profile.auth.tabs.includes('seguimiento_diario') ? 'SD' : user.profile.auth.tabs.includes('confirmacion_procesos') ? 'CP' : null }}
                    .h2.ad_text-secondary.m-0 {{ `${myToolsCount.tracing.done}/${user.profile.suggested_cp}`}}
        .col-12.col-lg-6
          .card.ad_border1-secondary.rounded-xxl.mb-0.position-relative.off-position
            .row.d-flex.align-items-center
              .col
                h4.text-primary.text-regular.mb-0.ml-2
                  | Compromisos 
                  small.ad_text-defaultText.font-italic
              .col-auto
                .h2.ad_text-secondary.mb-0.mr-2 {{ totalRows }}
          
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  table.table-bg-white.w-100
                    thead
                      tr
                        td.px-2.pb-2 Descripción de lo tratado
                        td.px-2.pb-2 Origen
                        td.px-2.pb-2 Responsable
                        td.px-2.pb-2 Objetivo
                        td.px-2.pb-2.text-nowrap Fecha Comp.
                        td.px-2.pb-2 Antigüedad
                        td
                    tbody.bg-white
                      tr.border-bottom(v-for="(commitment, n) in commitmentsAssociatedWithUser")
                        td.px-2.py-1
                            | {{ commitment.description }} 
                        td.px-2.text-center
                            | {{ commitment.tracing ? commitment.tracing.type : 'DDD' }}
                        td.px-2.text-center
                            | {{ commitment | Responsibles(commitment)}}
                        td.px-2.text-center
                          a(:id="'objetivoCE-' + n")  
                            i.icono.icono-objetivos.ad_text-primary
                          b-tooltip(:target="'objetivoCE-' + n", placement="top")
                            | {{commitment.tracing ? `${commitment.tracing.objectives[0].travel ? commitment.tracing.objectives[0].travel.name : ''}-${commitment.tracing.objectives[0].product ? commitment.tracing.objectives[0].product.name : ''}-${commitment.tracing.objectives[0].segment ? commitment.tracing.objectives[0].segment.name : ''} | ${commitment.tracing.objectives[0].business_type.name}` : `${commitment.objective.S} | ${commitment.objective.P}` }}
                        td.px-2.text-center
                            | {{moment(commitment.scheduled).utc().format("DD/MM/YYYY")}}
                        td.px-2.text-center
                            span.ad_text-success(v-if="moment() < moment(commitment.scheduled)")
                              | {{ moment().format('W') - moment(commitment.date).format('W') === 0 ? 1 : moment().format('W') - moment(commitment.date).format('W') }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(commitment.scheduled)")
                              | {{ moment().format('W') - moment(commitment.date).format('W')  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(commitment.scheduled)")
                              | {{ moment().format('W') - moment(commitment.date).format('W') > 3 ? +3 : moment().format('W') - moment(commitment.date).format('W') }}&deg; sem
                        td.px-1
                          a.no-decoration(title="Comentarios" @click='openCommitmentCommentBox(commitment)')
                            i.icono.icono-comentarios.ad_text-primary
                  b-pagination(
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage",
                    @input="selectedPage()",
                    class="my-0")
        .col-12.col-lg-6(v-if="leader")
          .card.ad_border1-secondary.rounded-xxl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-items-center
              .col
                h4.text-primary.text-regular.mb-0.ml-2
                  | Mis {{textMyLeaders}}
              .col-auto
                .h2.ad_text-secondary.mb-0.mr-2 {{`${totalPlans}/${collabsInformation.length}`}}
          
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  table.table-bg-white.w-100
                    thead
                      tr
                        td.px-3 Nombre
                        td.px-3.text-right(v-if="user.profile.leader_leaders")  P.S
                        td.px-3.text-center(v-if="user.profile.leader_leaders") DDD
                        td.px-3.text-center(v-if="user.profile.leader_leaders") CP/SD
                    tbody.bg-white
                      tr.border-bottom(v-for="collab in collabsInformation")
                        td.px-3.py-2
                          | {{ collab.name }}
                        td.px-3.py-2.text-right(v-if="collab.leader")
                          | {{`${collab.plans.done}/${collab.plans.total}`}}
                        td.px-3.py-2.text-center(v-if="collab.leader")
                          | {{`${collab.meetings.done}/${collab.meetings.total}`}}
                        td.px-3.py-2.text-center(v-if="collab.leader")
                          | {{`${collab.tracings.done}/${collab.tracings.total}`}}

        .col-12.col-lg-6
          .card.ad_border1-secondary.rounded-xxl.mb-0.mt-4.position-relative.off-position
            .row.d-flex.align-content-center
              .col.align-self-center
                h4.text-primary.text-regular.mb-0.ml-2
                  | Objetivos de Desarrollo Personal
          
          .col.collapsible.ad_bg-gray.px-0.mt--3
            .card-body
              .row
                .col
                  table.table-bg-white.w-100
                    thead
                      tr                        
                        td.px-3.pb-2 Objetivo
                        td.px-3.pb-2 Categoría
                        td.px-3.pb-2 Antigüedad
                        td
                    tbody.bg-white
                      tr.border-bottom(v-for="personalCommitment in personalCommitments")
                        td.p-3(v-if="personalCommitment.subcategory")
                            | {{personalCommitment.subcategory.name}}
                        td.p-3.text-center(v-if="personalCommitment.category")
                            p.m-0.text-nowrap {{ personalCommitment.category.name }}
                        td.p-3.text-center
                            span.ad_text-danger
                              | {{personalCommitment.creation_date | WeekDuration}}&deg; sem 
                        td.px-1
                            a.no-decoration(title="Comentarios" @click='openPersonalCommentBox(personalCommitment)')
                              i.icono.icono-comentarios.ad_text-primary
                  b-pagination(
                    v-model="currentPagePC"
                    :total-rows="totalRowsPC"
                    :per-page="perPagePC",
                    @input="selectedPagePC()",
                    class="my-0")
    
    v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col
          label
            i.icon-letters.icon-letters__viaje.mr-1 S
            | {{ isTracing ? `${item.tracing.objectives[0].travel ? item.tracing.objectives[0].travel.name : ''}-${item.tracing.objectives[0].product ? item.tracing.objectives[0].product.name : ''}-${item.tracing.objectives[0].segment ? item.tracing.objectives[0].segment.name : ''}` : item.objective.S }}
          label
            i.icon-letters.icon-letters__kpi.mr-1 P
            | {{ isTracing ? `${item.tracing.objectives[0].business_type.name}` : item.objective.P }}
        .row.align-items-end
          .col
            .col-12
              h4 {{ item.description }}
          .col-auto.pr-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Registro
              span {{ isTracing ? `${item.tracing.objectives[0].kpipercentage}` : `${item.objective.kpipercentage}`}}%
            p.d-inline-block.mb-0.ad_text-grayMedio
              sup Meta
              span {{ isTracing ? `${item.tracing.objectives[0].kpi.goal}` : `${item.objective.goal}` }}%
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer=false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommitmentComment(item._id)")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          div(v-if="item")        
            .row.mb-3(v-for='comm in (item.comments? item.comments.slice().reverse(): [])')
              .col-4.pr-0
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{moment(comm.creation_date) | DateFormat}}
                small.d-block {{moment(comm.creation_date) | HourFormat}} hrs.
              .col-8.pl-0
                .dialog-box
                  p {{comm.description}}  

    v-navigation-drawer(v-model='drawer_personal', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .row.align-items-end
          .col
            .col-12 Objetivo
              h4 {{ personal.name }}
        .row.align-items-end
          .col
            .col-12 Categoria 
              h4 {{ personal.category.name }}
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer_personal=false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addPersonalComment(personal._id)")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          div(v-if="personal")        
            .row.mb-3(v-for='comm in personal.comments')
              .col-4.pr-0
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{moment(comm.creation_date) | DateFormat}}
                small.d-block {{moment(comm.creation_date) | HourFormat}} hrs.
              .col-8.pl-0
                .dialog-box
                  p {{comm.description}}  

    v-navigation-drawer(v-model='drawer_objective', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col
          label
            i.icon-letters.icon-letters__viaje.mr-1 S
            | {{ `${objective._id.travel}/${objective._id.product}/${objective._id.segment}` }}
          label
            i.icon-letters.icon-letters__kpi.mr-1 P
            | {{ objective._id.business_type }}
        .row.align-items-end
          .col
            .col-12
              h4 {{ objective.selected.kpi }}
          .col-auto.pr-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Registro
              span {{ objective.selected.register }}%
            p.d-inline-block.mb-0.ad_text-grayMedio
              sup Meta
              span {{ objective.selected.goal }}%
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer_objective=false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addObjectiveComment(objective.selected.id)")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          div(v-if="objective")        
            .row.mb-3(v-for='comm in (objective.selected.comments ? objective.selected.comments.slice().reverse(): [])')
              .col-4.pr-0(v-if="comm != null")
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{moment(comm.date) | DateFormat}}
                small.d-block {{moment(comm.date) | HourFormat}} hrs.
              .col-8.pl-0(v-if="comm != null")
                .dialog-box
                  p {{comm.text}}  

</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex';

export default {
  name: 'EstadoGeneral',
  data() {
    return {
      drawer: false,
      drawer_personal: false,
      drawer_objective: false,
      team: false,
      arrTeam: {},
      CP: null,
      DDD: null,
      collabs: null,
      user: {},
      comment: '',
      cumplimiento: null,
      plan: null,
      objectives: null,
      myToolsCount: { meeting: {total: 0, done: 0}, tracing: { total: 0, done: 0 } },
      commitmentsAssociatedWithUser: [],
      collabsInformation: [],
      totalPlans: 0,
      commitmentsFromTracing: [],
      numberOfCommitmentsTracing: { others: 0, personal: 0},
      personalCommitments: [],
      item: { objective: { S: null, P: null }, description: null },
      personal: { name: null, category: { name: null } },
      objective: { _id: { travel: '', segment: '', product: '', business_type: '' }, selected: { kpi: '', register: 0, goal: 0, id: '' } },
      isTracing: false,
      leader: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      totalRowsPC: 0,
      currentPagePC: 1,
      perPagePC: 10,
      totalPagesPC: 0,
      textMyLeaders: "líderes" 
    }
  },
  methods: {
    moment,
    ...mapActions('user', [
      'myTools',
      'objectivesInPlan',
      'commitmentsAssociated',
      'collabsWeekInformation',
      'personalCommitmentsByTracings',
      'pendingPersonalCommitments'
    ]),
    ...mapActions('plan', [ 
      'planByWeek' 
    ]),
    ...mapActions('commitment', [
      'addCommentToCommitment'
    ]),
    ...mapActions('personalcommitments', [
      'addCommentToPersonalCommitment'
    ]),
    ...mapActions('objective', [
      'addComment'
    ]),
    getObjectives(user_id) {
      const vm = this;
      const data = { 
        plan: vm.plan ? vm.plan._id : null,
        user_id
      }
      vm.objectivesInPlan(data).then(response => {
        vm.objectives = response.objectives
      })
    },
    getTools() {
      const vm = this;
      vm.myTools(vm.plan._id).then(response => {
        vm.myToolsCount.meeting.total = response.meeting.total
        vm.myToolsCount.meeting.done = response.meeting.done
        vm.myToolsCount.tracing.total = response.tracing.total
        vm.myToolsCount.tracing.done = response.tracing.done
      })
    },
    getCommitments() {
      const vm = this;
      const loading = vm.$toast.loading("Cargando...");
      vm.commitmentsAssociated({id: vm.user.id, pagination: {page: vm.currentPage, perPage: vm.perPage}}).then((response) => {
        vm.commitmentsAssociatedWithUser = response.docs
        vm.currentPage = response.page
        vm.totalRows = response.total
        vm.totalPages =  response.totalPages
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: "danger",
          title: "Notificación",
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      })
    },
    getPendingPersonalCommitments() {
      const vm = this;
      const loading = vm.$toast.loading("Cargando...");
      vm.pendingPersonalCommitments({id: vm.user.id, pagination: {page: vm.currentPagePC, perPage: vm.perPagePC}}).then((response) => {
        vm.personalCommitments = response.docs
        vm.currentPagePC = response.page
        vm.totalRowsPC = response.total
        vm.totalPagesPC =  response.totalPages
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: "danger",
          title: "Notificación",
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      })
    },
    getCollabsWeekInformation() {
      const vm = this;
      vm.collabsWeekInformation(vm.user.id).then(response => {
        vm.collabsInformation = vm.$store.getters['user/getMyCollabsInformation']
        vm.totalPlans = response
        vm.getTextMyLeaders()

      })
    },
    getPersonalCommitments() {
      const vm = this;
      vm.personalCommitmentsByCatSubcat(vm.user.id).then(response => {
        vm.personalCommitments = response.personalCommitments
      })
    },
    openCommitmentCommentBox(item) {
      const vm = this;
      vm.isTracing = item.tracing ? true : false
      vm.item = item
      vm.comment = ''
      vm.drawer = true
    },
    openPersonalCommentBox(item) {
      const vm = this;
      vm.personal = item
      vm.comment = ''
      vm.drawer_personal = true
    },
    openObjectiveCommentBox(item, objective) {
      const vm = this;
      vm.objective = item
      vm.objective.selected = objective
      vm.comment = ''
      vm.drawer_objective = true
    },
    addCommitmentComment(_id) {
      const vm = this
      const data = {
        description: vm.comment,
        _id,
        user: vm.$store.state.auth.user.name
      }
      if (vm.comment != '') {
        vm.addCommentToCommitment(data).then(response => {
          vm.item.comments = response.reverse()
        })
      }
    },
    addPersonalComment(_id) {
      const vm = this;
      const data = {
        description: vm.comment,
        _id,
        user: vm.$store.state.auth.user.name
      }
      if (vm.comment != '') {
        vm.addCommentToPersonalCommitment(data).then(response => {
          vm.personal.comments = response.reverse()
        })
      }
    },
    addObjectiveComment(id) {
      const vm = this;
      const data = {
        comment: {
          text: vm.comment,
          user: vm.$store.state.auth.user.name,
          date: Date.now()
        },
        id,
      }
      if (vm.comment != '') {
        vm.addComment(data).then(response => {
          vm.objective.selected.comments = response.reverse()
        })
      }
    },
    selectedPage() {
      const vm = this
      vm.getCommitments()
    },
    selectedPagePC() {
      const vm = this
      vm.getPendingPersonalCommitments()
    },
    getTextMyLeaders() {
      const vm = this
      let leaderFound = false
      for (let u of vm.collabsInformation) {
        if (u.leader) {
          leaderFound = true
          break
        }
      }
      if (!leaderFound) {
        vm.textMyLeaders = 'Colaboradores'
      }
    }
  },
  mounted() {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    vm.user = vm.$store.getters['auth/getUserInfo']
    if (vm.user.profile.name == 'Consultor' || vm.user.profile.name == 'Consultor externo') {
      if (vm.user.profile.name == 'Consultor') {
        vm.$router.replace({ path: '/consultor' })
      } else if (vm.user.profile.name == 'Consultor externo') {
        vm.$router.replace({ path: '/dashboard' })
      } else {
        vm.$router.replace({ path: '/permission' })
      }
    } else {
      vm.leader = vm.user.leader
      // console.log(id)
      vm.planByWeek({date: Date.now(), id}).then(() => {        
        vm.plan = vm.$store.getters['plan/getPlan']
        if (vm.plan) {
          vm.getTools()
        }
        vm.getObjectives(id)
        vm.getCommitments()
        vm.getCollabsWeekInformation()
        vm.getPendingPersonalCommitments()
      })
    }
  },
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/home.vue